import React, { useState } from "react";
import { CustomSecondaryInput } from "../../Core/Components/CustomInput";

const Screen4 = ({ setScreen, details, setDetails }) => {
  const [error, setError] = useState("");

  const handleContinue = () => {
    const drivers = Number(details.drivers);

    if (!Number.isInteger(drivers) || drivers <= 0) {
      setError("Please enter a valid number");
      return;
    }

    setScreen(5);
  };

  return (
    <div className="flex flex-col">
      <h1 className="font-poppins text-2xl text-background-white font-semibold text-center">
        Team information
      </h1>

      <p className="my-4 font-poppins text-sm font-normal text-background-white-hover text-center">
        How many drivers are part of your team?
      </p>

      <CustomSecondaryInput
        value={details.drivers}
        onChange={(e) => {
          setDetails({ ...details, drivers: e.target.value });
          setError("");
        }}
      />

      {error ? (
        <p className="mt-2 font-poppins text-xs font-normal text-background-white-hover">
          {error}
        </p>
      ) : null}

      <button
        type="button"
        className="mt-[50px] w-full h-[42px] py-3 rounded-md bg-yellow hover:bg-yellow-dark disabled:cursor-pointer"
        // onClick={() => setScreen(5)}
        onClick={handleContinue}
        disabled={details.drivers === ""}
      >
        <p className="font-poppins text-xs font-medium">Continue</p>
      </button>
    </div>
  );
};

export default Screen4;
